module.exports = __webpack_public_path__ + "img/modal-gray.18830bc2.svg";